import Base from './action-base'
import renderFields from './notification.pug'

export default class Notification extends Base
  Object.defineProperty this, "label", get: -> @t(".label")
  @icon = "fa-bell"

  @DEFAULTS:
    title: ""
    text: ""
    instanceId: null
    delay:
      seconds: 0

  renderFields: renderFields
